import React from 'react'
import styled from 'styled-components'
import MapStatus from './stage/MapStatus'
import MapContainer from './stage/MapContainer'
import MapController from './stage/MapController'
import MapTooltip from './tooltip/MapTooltip'
import LayerSelector from '@/components/shared/map/layer-selector/LayerSelector'
import { ModelViewer } from './model-viewer'
import { Map3D } from './geo-map/Map3D'
import { useGlobalStore } from '@/stores/globalStore'

const MODEL_LAYER_ID = 9171
const GEO_MAP_LAYER_ID = 9317

const Map: React.FC = () => {
  const activeLayer = useGlobalStore(state => state.activeLayer)
  const layerId = Number(activeLayer)

  if (layerId === MODEL_LAYER_ID) {
    return (
      <MapWrapper>
        <ModelViewer />
      </MapWrapper>
    )
  }

  if (layerId === GEO_MAP_LAYER_ID) {
    return (
      <MapWrapper>
        <Map3D />
      </MapWrapper>
    )
  }

  return (
    <MapWrapper>
      <MapContainer />
      <MapStatus />
      <MapController />
      <LayerSelector />

      <MapTooltip />
    </MapWrapper>
  )
}

Map.whyDidYouRender = true

export default Map

const MapWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`
